<template lang="pug">
v-card.scheduleRow(:color="vCardColor")
  v-chip.scheduleRow_chip(v-if="isNew" color="guide" text-color="white" small) New
  v-card-title.pb-1(primary-title)
    div.headline {{ value.theme.title }}
  v-card-text.pa-1.pr-3.text-xs-right
    template(v-if="value.answerable")
      v-icon.body-2.pr-1(v-text="$vuetify.icons.endAt")
      | {{ endAt }}
    span.body-2.accent--text(v-else)
      | {{ this.$t('pages.user.theme_schedules.row.answerNotPossible') }}
  v-divider
  v-card-actions
    btn-icon(
      v-if="value.groups.length > 0"
      icon="themeScheduleGroup"
      :tooltip="$t('model.group')"
      :iconColor="expantion ? 'accent' : null"
      @click.native="expantion = !expantion")
    v-spacer
    template(v-if="value.isAnswered")
      text-answered-at.mr-1.caption(:value="value.answer.answered_at")
      btn-icon.ml-2(
        v-if="value.answer.isPermitResult"
        icon="analyze"
        iconColor="green accent-4"
        :tooltip="$t('text.showResults')"
        @click="onResult")
      btn-icon.ml-2(
        v-else
        icon="history"
        :tooltip="$t('pages.user.user.answers.title')"
        @click="onHistory")
    btn-icon.ml-2(
      icon="themeAnswer"
      :color="answerButtonOptions.color"
      :tooltip="answerButtonOptions.tooltip"
      :disabled="answerButtonOptions.disabled"
      @click="onAnswer")
  v-slide-y-transition
    v-card-text(v-show="expantion")
      chips(
        v-for="group in value.groups"
        :key="group.id"
        :text="group.name")
</template>

<script>
import Schedule from '@/models/schedule'
import BtnIcon from '@/components/button/BtnIcon'
import Chips from '@/components/Chips'
import TextAnsweredAt from '@/components/text/TextAnsweredAt'
import TimeSupport from '@/utils/time-support'

export default {
  components: {
    BtnIcon,
    Chips,
    TextAnsweredAt
  },
  props: {
    value: {
      type: Schedule,
      required: true
    },
  },
  data () {
    return {
      expantion: false
    }
  },
  computed: {
    vCardColor () {
      if (this.value.answerable) return null
      return "blue-grey lighten-5"
    },
    answerButtonOptions () {
      if (this.value.answerable) {
        return {
          color: 'primary',
          tooltip: this.$t('text.answer'),
          disabled: false
        }
      } else {
        return {
          color: 'gray lighten-2',
          tooltip: this.$t('pages.user.theme_schedules.row.canNotAnswer'),
          disabled: true
        }
      }
    },
    endAt () {
      if (this.value.answerable) {
        return this.value.end_at.humanWithSuffix(this.$t('text.endAtSuffix'))
      } else {
        return this.$t('pages.user.theme_schedules.row.answerNotPossible')
      }
    },
    isNew () {
      return !this.value.answer
    }
  },
  methods: {
    onAnswer () {
      this.$emit('answer', this.value)
    },
    onResult () {
      this.$emit('result', this.value.answer)
    },
    onHistory () {
      this.$emit('history', this.value.theme)
    }
  }
}
</script>

<style lang="styl" scoped>
.scheduleRow_chip
  position absolute
  top -12px
</style>
